



























import { Typ } from '@/modules/ciselnik/dilenske/typ';
import { listFactory } from '@/main/pages';

import { NAME } from './constants';
import { store } from './store/list';
import { listMutations } from './store/types';

export default listFactory(NAME, store).extend({
	components: {
		TypSelect: Typ.components.Select,
	},
	computed: {
		mutationsMappers() {
			return {
				typkod: `${this.storeUri}/${listMutations.SKLAD_OV_FILTER_TYPKOD}`,
			};
		},
		typkodFilter() {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
			};
		},
	},
});
